import ACTIONS from '~shared/actions';
import { Packages } from '~shared/constants/pricing';
import { ActionMap, CombinedActions } from '~shared/types/pricing/actions';

export type Grow2792StateType = {
  advantageUsers: number;
  premierUsers: number;
  initialLoad: boolean;
  isIPPM: boolean;
};

export type Grow2792PayloadType = {
  [ACTIONS.PNP_REFRESH_CHANGE_USERS]: {
    users: string;
    packageType: string;
  };
  [ACTIONS.PNP_REFRESH_INITIAL_LOAD]: {
    loadedState: boolean;
  };
  [ACTIONS.PNP_REFRESH_RESET_TOGGLE_SWITCH]: {
    packageType: string;
  };
  [ACTIONS.PNP_REFRESH_RESET_ALL]: undefined;
};

export type Grow2792ToggleProps = {
  packageName: string;
};

export enum PaidFeatures {
  RANDOM_ASSIGNMENT = 'random_assign',
  BLOCK_RANDOMIZATION = 'block_randomization',
  FUNNELING = 'funneling',
  LOGO = 'logo',
  FOOTER = 'footer',
  PAGESKIPLOGIC = 'page_logic',
  PAGE_RANDOMIZATION = 'page_randomization',
  QUESTION_RANDOMIZATION = 'question_randomization',
  QUOTAS = 'quotas',
  CUSTOM_VARIABLES = 'custom_variables',
  THEMES = 'custom_theme',
  QUESTIONSKIP_LOGIC = 'question_logic',
  PIPING = 'piping',
  QUESTION_MATRIX = 'matrix_question_type',
  QUESTION_MENU_MATRIX = 'matrix_menu',
  QUESTION_FILE_UPLOAD = 'file_upload',
  MULTILINGUAL = 'multilingual',
  QUIZZES_PRO = 'pro_quiz',
  QUESTION_PAYMENT = 'payment_qt',
  QUESTION_CLICK_MAP = 'click_map',
  FOOTER_GRAYSCALE = 'footer_grayscale',
  PREMIUM_THEMES = 'premium_theme',
  CUSTOM_AVATAR = 'custom_avatar',
  COMMENT_BOX = 'comment_box_question_type',
  CONTACT_INFO = 'collect_contact_information',
  MULTIPLE_TEXTBOXES = 'textbox_multiple_question_type',
  RANKING = 'ranking_question_type',
  SLIDER = 'slider_question_type',
  STAR_RATING_SCALE = 'star_rating_question_type',
  QUESTION_BEST_WORST = 'best_worst',
  THEME_LAYOUT = 'theme_layout',
  QUESTION_LIMIT = 'question_limit',
  ADVANCED_BRANCHING = 'advanced_branching',
}

export type Grow2792Actions = ActionMap<Grow2792PayloadType>[keyof ActionMap<Grow2792PayloadType>];

export type SwitchAndSaveProps = {
  numberOfUsers: string;
  isAdvantagePackage: boolean;
  isPremierPackage: boolean;
  pageName: string;
  dispatch: React.Dispatch<CombinedActions>;
  packageName?: Packages;
  isAdvantageMonthlyCurrentlySelected?: boolean;
};
